// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2lXMS","header":"styles_header__24sw9","logo":"styles_logo__Dqigz","body":"styles_body__1KGpI","footer":"styles_footer__1A5Ar"};